module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABKUlEQVQoU4WSu0pDQRRF174JFpYKPjoRS63ygIh+gaKFgp1djJ2kClEQLDSkCkIsbpLKShELRb9AUZD4ByJWktjbiPcemZCIXsFMd87sdR6zR0ROsmZLgpJLGxSbG7r8KVEvSPg254kyMBupcRcahcecbl1eyYZNK+xUXIx2i8RX5lFUqmYtYLSPuHf9pnTVhm0AH1jpA53rg5xSvlURa8AhxiRiHYh14QDjGPEMbAlO3EhHDlBIJYBK3JgIPPYdEAvZ+RQvMcibRx7jVJmGDQUhvsEqoiVjb/CVhgPex8nisYsxhjiLi03XoQ2MRN76qevDVGSvthK+zUiUBAv/LW1wbUbx27h03eYNyhiZX6C4FxQesrrpGPfna9RtWcZBZySx3czq4qfmCzcPX/QhavJmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/media_type.png
// module id = ni4p
// module chunks = 1